export default {"src":"/_next/static/media/transcript-icon.98227d60.svg","height":19,"width":18};